import { driver, DriveStep } from 'driver.js';
import 'driver.js/dist/driver.css';
import './tour.css';

const STORAGE_PREFIX = 'sainhursh_tour_done_';

const STEPS: DriveStep[] = [
  {
    popover: {
      title: '👋 Тавтай морил!',
      description:
        'Сайн Хөрш системд тавтай морил. Энэхүү богино танилцуулгаар үндсэн цэсүүдийг ' +
        'танилцуулъя. Хүссэн үедээ Esc дарж хаах боломжтой.',
    },
  },
  {
    element: '[data-tour="nav-dashboard"]',
    popover: {
      title: 'Хянах самбар',
      description:
        'Өдөр тутмын ажлаа эндээс эхэлнэ — орон сууц, оршин суугчийн тоо, төлөлтийн явц, ' +
        'нээлттэй хүсэлтүүд нэг дор харагдана.',
      side: 'left',
    },
  },
  {
    element: '[data-tour="nav-group-Бүртгэл"]',
    popover: {
      title: 'Бүртгэл',
      description:
        'Орон сууц (тоот), оршин суугч, автозогсоол, тоолуурын бүртгэл энд байна. ' +
        'Оршин суугч бүртгэхэд нэвтрэх мэдээлэл нь имэйлээр автоматаар илгээгдэнэ.',
      side: 'left',
    },
  },
  {
    element: '[data-tour="nav-group-Санхүү"]',
    popover: {
      title: 'Санхүү',
      description:
        'Сарын нэхэмжлэх үүсгэх, төлбөр бүртгэх, банкны хуулга тулгах, өр авлага хянах, ' +
        'eBarimt баримт олгох — санхүүгийн бүх үйлдэл энд.',
      side: 'left',
    },
  },
  {
    element: '[data-tour="nav-group-Үйл ажиллагаа"]',
    popover: {
      title: 'Үйл ажиллагаа',
      description:
        'Оршин суугчдын засварын хүсэлт, санал асуулга, зөвлөлийн бүртгэл, баримт бичгийн сан.',
      side: 'left',
    },
  },
  {
    element: '[data-tour="nav-group-Мэдээлэл"]',
    popover: {
      title: 'Мэдээлэл',
      description:
        'Зарлал нийтлэхэд бүх оршин суугчийн апп-д харагдаж, push мэдэгдэл очно. ' +
        'Тодорхой хүнд чиглэсэн мэдэгдэл мөн эндээс илгээнэ.',
      side: 'left',
    },
  },
  {
    element: '[data-tour="nav-group-Тайлан"]',
    popover: {
      title: 'Тайлан',
      description: 'Төлөлтийн шинжилгээ, график, CSV экспорт.',
      side: 'left',
    },
  },
  {
    element: '[data-tour="nav-group-Тохиргоо"]',
    popover: {
      title: 'Тохиргоо',
      description:
        'Тарифаа эхлээд энд тохируулаарай — нэхэмжлэх үүсгэхэд ашиглагдана. ' +
        'Менежер, нягтлангийн эрхийг мөн эндээс нээнэ.',
      side: 'left',
    },
  },
  {
    element: '[data-tour="help-button"]',
    popover: {
      title: 'Танилцуулгыг дахин үзэх',
      description:
        'Энэ товчоор танилцуулгыг хүссэн үедээ дахин эхлүүлж болно. Ажилдаа амжилт хүсье! 🎉',
      side: 'top',
    },
  },
];

export function startAdminTour(onDone?: () => void) {
  const tour = driver({
    showProgress: true,
    progressText: '{{current}} / {{total}}',
    nextBtnText: 'Дараах',
    prevBtnText: 'Өмнөх',
    doneBtnText: 'Дуусгах',
    overlayOpacity: 0.65,
    stagePadding: 6,
    stageRadius: 10,
    popoverClass: 'sainhursh-tour',
    steps: STEPS,
    onDestroyed: () => {
      onDone?.();
    },
  });
  tour.drive();
}

export function isTourDone(userId: string): boolean {
  return localStorage.getItem(STORAGE_PREFIX + userId) === '1';
}

export function markTourDone(userId: string) {
  localStorage.setItem(STORAGE_PREFIX + userId, '1');
}

/** Show the tour automatically on the user's first login on this device. */
export function maybeStartAdminTour(userId: string | undefined) {
  if (!userId || isTourDone(userId)) return;
  // Let the layout render before highlighting elements.
  window.setTimeout(() => {
    startAdminTour(() => markTourDone(userId));
  }, 600);
}
